import { call, put, takeLatest, all } from "redux-saga/effects";

import {
  REQUEST_API_DATA,
  REQUEST_FUSEBILL_DATA,
  REQUEST_CREATE_FUSEBILL_CUSTOMER,
  REQUEST_SAVE_FUSEBILL_CARD_ID,
  REQUEST_SAVE_FUSEBILL_PAYMENT_METHOD,
  GET_ALL_SITE,
  REQUEST_COUNTRY_DATA,
  GET_TRANSCARD_PAYMENT_METHODS,
  DISBURSE_AMOUNT,
  TRANSFER_FUNDS_TO_ACH,
  TRANSFER_FUNDS_TO_CARD,
  REQUEST_UPLOADFILE_DATA,
  QUESTION_TYPE_FILE,
  QUESTION_TYPE_FILE_DELETE,
  REQUEST_UPLOADFILE_DATA_DOC,
  REQUEST_CHILDCOMPAY_DATA,
  receiveApiData,
  receiveProfileApiData,
  receiveFuseBillData,
  receiveFusebillCardId,
  receiveFusebillPaymentMethod,
  receiveAllSitePages,
  receiveAffiliateUser,
  receiveAllCountry,
  receiveDisbursePayment,
  receiveTransferFundsToACH,
  receiveTransferFundsToCard,
  receiveAllPaymentMethods,
  REQUEST_SAVE_APPLY_NEXT_QUESTION,
  GET_ALL_ELIGIBILITY_BACK,
  REQUEST_ALL_PROMOTED_SETTLEMENT,
  REQUEST_BUSINESSCOMPANY_DATA,
  REQUEST_VIEW_BUSINESSCOMPANY_DATA,
  REQUEST_BUSINESSCOMPANY_UPDATE_DATA,
  REQUEST_CONSUMERUPDATE_DATA,
  REQUEST_DEFENDENT_AUTO_DATA,
  REQUEST_BUSINESSUPDATE_DATA,
  SAVE_BUSINESS_USER_DATA,
  SAVE_BUSINESS_USER_DATA_PARTNER,
  SAVE_BUSINESS_USER_DATA_FIRST_STEP,
  CLEAR_BUSINESS_USER_DATA_FIRST_STEP,
  REQUEST_AFFILIATE_DATA,
  GET_ALL_VEHICLE_YEAR,
  GET_ALL_EXTERNAL_VEHICLE_DATA,
  GET_ALL_TOTAL_FUND_DATA,
  REQUEST_VEHICLE_MODEL_DATA,
  REQUEST_VEHICLE_MAKE_DATA,
  receiveSavedUploadFile,
  receieveUploadEligibilityQuestionFileByUser,
  receiveDeleteEligibilityQuestionFileByUser,
  receiveSavedUploadFileDoc,
  receiveSavedConsumerUser,
  SAVE_CONSUMER_USER_DATA,
  receiveUpdateBusinessUser,
  receiveUpdateConsumerUser,
  receiveAutoPartDefendentPartsByPartId,
  receiveUsersUneligibleSettlements,
  receiveSavedBusinessUser,
  receiveSavedBusinessUserPartner,
  receiveUpdateBusinessCompany,
  GET_ALL_STATES,
  REQUEST_BUSINESSUSER_DATA,
  REQUEST_NOTIFICATION_DATA,
  REQUEST_BUSINESSUSER_DATA_AFFI,
  receiveAllStates,
  REQUEST_FORGET_PASSWORD,
  receiveForgetPasswordData,
  receiveAllPlans,
  GET_ALL_PLANES,
  receiveconfirmUserEmail,
  REQUEST_USER_EMAIL,
  REQUEST_RESET_PASSWORD,
  receiveResetPassword,
  receiveConsumerUser,
  receiveUpdateAutoSettlementFlag,
  receiveChildCompanyProfile,
  receiveBusinessUser,
  receiveNotificationLogUnReadCountForUser,
  receiveBusinessUserAffilate,
  receiveBusiness,
  REQUEST_CONSUMERUSER_DATA,
  LINK_ACCOUNT_PROFILE_PAGE,
  LINK_CARD_PROFILE_PAGE,
  GET_ADDED_BANK_ACCOUNT_FOR_USER,
  GET_ADDED_CARDS_FOR_USER,
  GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER,
  GET_ALL_BANK_ACCOUNTS_FOR_USER,
  GET_ALL_ADDED_CARDS_FOR_USER,
  GET_USER_TRANSACTION_HISTORY,
  SHOW_NET_AMOUNT_TO_USER,
  SET_DEFAULT_BANK_ACCOUNT,
  SET_DEFAULT_CARD,
  ADD_USER_CARD,
  ADD_BUSINESS_USER_CARD,
  RECEIVE_ADD_BUSINESS_USER_CARD,
  DELETE_USER_BANK_ACCOUNT,
  DELETE_USER_CARD,
  ADD_USER_BANK_ACCOUNT,
  RECIEVE_GET_ADDED_BANK_ACCOUNT_FOR_USER,
  RECIEVE_GET_ADDED_CARDS_FOR_USER,
  UPDATE_BANK_ACCOUNT_DETAILS,
  UPDATE_CARD_DETAILS,
  REQUEST_AUTO_UPDATE_DATA,
  REQUEST_BUSINESS_DATA,
  receiveIndustry,
  REQUEST_INDUSTRY_DATA,
  receiveSettlemetEnrichmentQuestion,
  REQUEST_SETTLEMENT_ENRICH_QUE,
  receiveAllSettlement,
  receivePromotedSettlementByUserId,
  receiveAllFilteredSettlement,
  receiveAllDFilteredSettlement,
  receiveAllReferredUserByAffiliateId,
  receiveAllGroupsByParentAffiliateUser,
  receiveEnrolledListByAffiliateId,
  receiveGetEnrolledListBySearchAndFilterForGroup,
  receiveEnrollForPartnerUser,
  receiveGetSettlementListForGroup,
  receiveSettlementListByAffiliateType,
  receiveSuccess,
  receiveAllEnrolledSettlement,
  receiveAllCategory,
  REQUEST_ALL_SETTLEMENT,
  REQUEST_ALL_FILTEREDSETTLEMENT,
  REQUEST_ALL_DASHBOARD_FILTEREDSETTLEMENT,
  REQUEST_ALL_FILTEREDSETTLEMENT_AFFILIATE,
  REQUEST_ALL_REFERRED_FILTEREDSETTLEMENT_AFFILIATEID,
  GET_ALL_GROUPS_BY_PARENT_AFFILIATE_USER,
  REQUEST_ALL_ENROLLED_FILTEREDSETTLEMENT_AFFILIATEID,
  GET_ENROLLED_LIST_BY_SEARCH_AND_FILTER_FOR_GROUP,
  REQUEST_ALL_ENROLLED_AFFILIATEID,
  GET_SETTLEMENT_LIST_FOR_GROUP,
  RECEIVE_GET_SETTLEMENT_LIST_FOR_GROUP,
  REQUEST_SAVE_UNELIGIBLE,
  REQUEST_ALL_ENROLLEDSETTLEMENT,
  REQUEST_ALL_CATEGORY,
  receiveEnrollSettlementForUser,
  REQUEST_SETTLEMENT_FOR_USER,
  receiveAlLFeatureSettlement,
  REQUEST_ALL_FEATURE_SETTLEMENT,
  REQUEST_ALL_ATTENTION_SETTLEMENT,
  REQUEST_ALL_COMPLETE_SETTLEMENT,
  receiveEnrichmentAnswer,
  SAVE_ENRICHMENT_QUESTION,
  GET_COGNITO_ID_BY_EMAIL,
  receiveCognitoIdByEmail,
  receiveconfirmCognitoUserEmail,
  REQUEST_CONFIRM_EMAIL_COGNITO,
  receiveGetSettlementById,
  GET_SETTLEMENT_QUESTION_ID,
  receiveViewCompanyChildRecord,
  receiveUpdateBusinessCompanyData,
  REQUEST_DELETE_BUSINESSCOMPANY_DATA,
  receiveDeleteCompanyChildRecord,
  receiveGetState,
  REQUEST_STATEID_DATA,
  VIEW_CONSUMER_RESIDENCE,
  receiveGetCity,
  REQUEST_CITYID_DATA,
  receiveUpdateAffiliateUser,
  REQUEST_UPDATE_AFFILIATE_DATA,
  REQUEST_AFFILIATESUBUSER_DATA,
  REQUEST_BUSINESSSUBUSER_DATA,
  receiveAffiliateSubUser,
  receiveBusinessSubUser,
  GET_ALL_CONSUMER_PLANES,
  receiveAllPlansConsumer,
  REQUEST_AFFILIATESUBUSERLIST_DATA,
  REQUEST_BUSINESSSUBUSERLIST_DATA,
  REQUEST_DELETE_AFFILIATESUBUSER_DATA,
  REQUEST_DELETE_BUSINESSSUBUSER_DATA,
  receiveAllAffiliatedUsers,
  receiveDeleteAffiliatedSubUser,
  receiveAttentionSettlementForUser,
  receiveCompleteSettlementForUser,
  SAVE_SETTLEMENT_ANSWERS,
  receiveSettlementAnswers,
  receiveEnrollmenttDoc,
  receiveUpdateEnrollmenttDoc,
  SAVE_ENROLMENT_DOC,
  UPDATE_ENROLMENT_DOC,
  receivecheckEmailVerify,
  CHECK_EMAIL_VERIFY,
  GET_AFFILIATE_USER_TYPE,
  GET_SUBUSERBYID_TYPE,
  GET_BUSINESSSUBUSERBYID_TYPE,
  GET_UPDATEAFFILIATESUBUSER_TYPE,
  GET_UPDATEBUSINESSSUBUSER_TYPE,
  receiveAffiliateSubUserById,
  receiveBusinessSubUserById,
  receiveUpdateAffiliateSubUser,
  receiveUpdateBusinessSubUser,
  receiveAffiliateUserType,
  SAVE_ENROLMENT_AUTH,
  receiveEnrollmentAuthorization,
  receiveCompletedSettlements,
  receiveAllBusinessSubUsers,
  GET_COMPLETED_SETTLEMENTS,
  GET_CONSUMER_RESIDENCE,
  receiveConsumerResidence,
  receiveAllVehicleYear,
  receivePendingRequiredDoc,
  receiveTotalFundSettlement,
  receiveExternalVehicleDataById,
  GET_PENDING_DOCS,
  receiveAllVehicleDataByUserIdAPI,
  receiveAllVehicleDataSettlementByUserIdAPI,
  receivesaveMultipleVehicleDataByUserIdAPI,
  GET_PENDING_DOCS_USER,
  GET_PENDING_DOCS_USER_DELETE,
  receivePendingRequiredDocUser,
  receivePendingRequiredDocUserDelete,
  GET_ALL_VEHICLE_DATA,
  GET_ALL_VEHICLE_DATA_SETTLEMENT,
  SAVE_MULTIPLE_VEHICLE_QUESTION_DATA,
  receiveAllVehicleMake,
  receiveAllVehicleModel,
  receivegetAllVehicleTrim,
  receiveAddVehicleData,
  REQUEST_VEHICLE_TRIM_DATA,
  REQUEST_VEHICLE_SAVE_DATA,
  REQUEST_VEHICLE_SAVE_DATA_CLEAR,
  REQUEST_VEHICLE_DATA_USERID_DATA,
  receiveAllVehicleDataByUserId,
  REQUEST_DELETE_VEHICLE_DATA_USERID_DATA,
  REQUEST_ALL_USER_SETTLEMENT_AFFILIATEID,
  REQUEST_ALL_SETTLEMENT_LIST_OF_USER_BY_ID_FOR_GROUP,
  GET_SETTLEMENT_DETAIL_FOR_GROUP,
  RECEIVE_GET_SETTLEMENT_DETAIL_FOR_GROUP,
  receivedeleteVehicleRecordsData,
  receiveAllSettlementListOfUserById,
  receiveAllSettlementListOfUserByIdForGroup,
  receiveGetSettlementDetailForGroup,
  receiveViewVehicleEditRecord,
  receivesaveResidences,
  receiveActivityLog,
  receiveChangePasswordData,
  receiveAffiliateDetailByAffiliateKey,
  REQUEST_VIEW_VEHICLE_DATA_USERID_DATA,
  REQUEST_SAVE_RESIDENCE_DATA,
  GET_ACTIVITY_LOG,
  DELETE_CONSUMER_RESIDENCE,
  receivedeleteConsumerResidence,
  receiveviewConsumerResidence,
  receiveDeleteBusinessSubUser,
  receivePendingSettlementQuestions,
  REQUEST_DISMISS_SETTLEMENT,
  receiveDismissSettlement,
  GET_PENDING_SETTLEMENT_QUESTION_ID,
  GET_FAQ_CATEGORY,
  GET_All_FAQ_QUESTIONS_BY_CATEGORY_ID,
  receiveFaqCategory,
  receiveFaqQuestionBYCategoryId,
  GET_PAGE_DATA,
  GET_PAGE_DATA_FOOTER,
  GET_PAGE_DATA_IDENTITY_KEY,
  GET_ACCEPT_DOCUMENT,
  GET_CLEAR_SERVICE_DATA,
  receivePageData,
  receivePageDataFooter,
  receiveUserByIdentityKey,
  receiveAcceptDocumentUpdateByAdmin,
  PLAN_PRICE_CHANGE,
  PLAN_PRICE_CHANGE_CLEAR,
  receivePlanPriceChange,
  GET_DISMISS_SETTLEMENT_FOR_USER,
  receiveDismissSettlementForUser,
  REQUEST_CHANGE_PASSWORD_DATA,
  GET_DETAIL_BYAFFILIATEKEY,
  receiveAllAffiliateLinkAction,
  GET_REGISTRATION_LINKS_FOR_USER,
  receiveSettlementWithoutData,
  REQUEST_APPLY_NEXT_QUESTION,
  GET_CLEAR_QUESTION_DATA,
  GET_CLEAR_ENROLLMENT_DATA,
  CLEAR_EMAIL_DATA,
  CLEAR_CONSUMER_LOGIN_DATA,
  CLEAR_BUSINESS_LOGIN_DATA,
  GET_CLEAR_CHANGEPASSWORD_DATA,
  GET_CLEAR_SETTLEMENTANSWER_DATA,
  receiveMoveToNextQuestionList,
  receiveMoveToSaveQuestion,
  receiveClearAffilate,
  receiveMoveToNextQuestion,
  receiveChangePassword,
  receiveDataSettlmentanswers,
  receivecheckEmailVerifyData,
  RecieveConsumerUserDataClearData,
  RecieveBussnessUserDataClearData,
  receiveSaveMoveToNextQuestionList,
  receiveMultipleVehicleData,
  receiveEligibilityQuestionById,
  SAVE_SETTLEMENT_WITHOUT_DATA,
  GET_PIE_DASHBOARD_DATA,
  GET_PIE_DASHBOARD_STATE_DATA,
  GET_BAR_DASHBOARD_DATA,
  GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER,
  GET_MONTHLY_ENROLLMENTS_BY_AFFILIATE_GROUP,
  GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER_FOR_GROUP,
  GET_AFFILIATE_DASHBOARD_DATA,
  GET_AFFILIATE_DASHBOARD_USER_FOR_PARENT,
  receivePieChartDataForDashboard,
  receivePieChartDataForStateDashboard,
  receiveBarGraphDataForDashboard,
  receiveGetBarGraphDataForDashboardWithSettlementIdForParentUser,
  receiveMonthlyEnrollmentsByAffiliateGroup,
  receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroup,
  receiveAffiliateDashboardUserAction,
  receiveGetAffiliateDashboardUserForParent,
  GET_ALL_NOTIFICATIONS,
  GET_MARK_NOTIFICATIONS,
  recieveAllNotifications,
  recievemarkNotificationReadForUser,
  DELETE_NOTIFICATION,
  MARK_ALL_READ_NOTIFICATIONS,
  GET_SAVE_MULTIPLE_VEHICLE_DATA,
  deleteNotificationSuccess,
  markNotificationSuccess,
  POST_UPLOADED_CHILD_COMPANY,
  receiveUploadedChildComapny,
  receiveAllDashboard,
  receiveAllDashboardCount,
  receiveAllAffiliateUsersByAffiliateType,
  GET_AFFILIATE_RESOURCE,
  GET_TRANSACTIONS_HISTORY,
  GET_DEBIT_WALLET_BALANCE,
  receivetResourceSectionsAndLinks,
  receivetUserTransactionsHistory,
  receivetDebitWalletBalance,
  GET_AFFILIATE_GROUP_SUCCESS,
  receiveGetAffiliateGroup,
  GET_DASHBOARD_DATA,
  GET_DASHBOARD_DATA_COUNT,
  GET_AFFILIATE_USER_TYPE_SIGNUP,
  receiveSavedBusinessUserStep1,
  receiveClearSignupData,
  receiveFusebillCountriesDataForCard,
  REQUEST_FUSEBILL_COUNTRIES_DATA_FOR_CARD,
  receiveTranscardAccountApi,
  receiveTranscardCardApi,
  receiveAddUserBankAccountApi,
  receiveUpdateBankAccountDetails,
  receiveUpdateCardDetails,
  receiveGetAddedBankAccountsForUser,
  receiveGetAddedCardsForUser,
  receiveGetCollectedSettlementsHistoryForUser,
  receiveGetAllBankAccountsForUser,
  receiveGetAllAddedCardsForUser,
  receiveGetUserTransactionsHistory,
  receiveShowNetAmountToUser,
  receiveSetDefaultBankAccount,
  receiveSetDefaultCard,
  receiveAddUserCard,
  receiveAddBusinessUserCard,
  receiveDeleteUserBankAccount,
  receiveDeleteUserCard,
  receiveAllPartnerByGroup,
  receiveAllHierarchyChildAffiliateUsersByParentAffiliateUser,
  GET_ALL_PARTNERS_BY_GROUP,
  GET_ALL_HIERARCHY_CHILD_AFFILIATE_USERS_BY_PARENT_AFFILIATE_USER
} from "../Actions/actions";
import {
  login,
  getAllSitePagesData,
  businessUserSignUp,
  businessUserSignUpPartner,
  updateBusinessCompanySave,
  updateBusinessCompanyDataSave,
  updateConsumerUser,
  createTranscardAccountApi,
  createTranscardCardApi,
  getAddedBankAccountsForUserApi,
  getAddedCardsForUserApi,
  getCollectedSettlementsHistoryForUserApi,
  getAllBankAccountsForUserApi,
  getAllAddedCardsForUserApi,
  showNetAmountToUserApi,
  setDefaultCardApi,
  setDefaultBankAccountApi,
  addUserCardApi,
  addBusinessUserCardApi,
  deleteUserBankAccountApi,
  deleteUserCardApi,
  addUserBankAccountApi,
  updateBankAccountDetailsApi,
  updateCardDetailsApi,
  getAutoPartDefendentPartsByPartIdApi,
  saveUsersUneligibleSettlementsApi,
  updateBusinessUser,
  saveUploadFile,
  saveUploadEligibilityQuestionFileByUser,
  saveDeleteUploadEligibilityQuestionFileByUser,
  updateUserSignatureWithDocsApi,
  saveConsumerUserSignUp,
  getConsumerUserProfile,
  getAutoUpdateUserApi,
  getAllChildCompanyProfileData,
  getAffiliateDataUser,
  getAllCountryData,
  getDisbursePayment,
  getTransferFundsToACH,
  getTransferFundsToCard,
  getTranscardPaymentMethodsApi,
  getBusinessUserProfile,
  getNotificationLogUnReadCountForUserApi,
  viewCompanyChildRecordSave,
  getAllStates,
  changeForgetPassword,
  getAllPlans,
  ConfirmCodeApi,
  resetPassword,
  getForBusinessAndIndustry,
  SettlemetEnrichmentQuestionApi,
  getAllSettlementApi,
  getPromotedSettlementByUserIdData,
  getSettlementListByAffiliateTypeData,
  getAllFilteredSettlementApi,
  getAllFilteredDSettlementApi,
  getAllEnrolledSettlementApi,
  getAllCategoryAPI,
  getEnrollSettlementForUserApi,
  getAttentionSettlementForUserApi,
  getCompleteSettlementForUserApi,
  getAlLFeatureSettlementApi,
  saveEnrichmentQuestionAnswerApi,
  getCognitoIdByEmailOfUser,
  ConfirmUserCodeApi,
  getSettlementById,
  deleteCompanyChildRecordSave,
  getStateData,
  getCityByStateIdData,
  getUpdateAffiliateUserData,
  saveAffilateSubUserSignUp,
  saveBusinessSubUserSignUp,
  getAllPlansConsumer,
  getAffliliateUsers,
  getBusinesssSubUsers,
  deteteAffliliateUsers,
  deteteBusinessUsers,
  saveSettlementAnswersResponse,
  uploadEnrolmentDoc,
  updateUploadEnrolmentDoc,
  emailVeriy,
  getAffiliateType,
  getAffiliateSubUserDataById,
  getBusinessSubUserDataById,
  updateAffiliateSubUserData,
  updateBusinessSubUserData,
  enrollmentAuthorizationApi,
  getAllUserResidenceByUserId,
  getAllVehicleYearData,
  getPendingRequiredDocApi,
  getPendingRequiredDocUserApi,
  getPendingRequiredDocUserDeleteApi,
  getAllVehicleDataByUserIdAPI,
  getAllVehicleDataSettlementByUserIdAPI,
  saveMultipleVehicleDataByUserIdAPIList,
  getTotalFundSettlementData,
  getAllVehicleMakeData,
  getExternalVehicleDataByIdData,
  getAllVehicleModelData,
  getAllVehicleTrimData,
  saveVehicleData,
  saveAffilateSubUserSignUpServer,
  saveBusinessSubUserSignUpServer,
  getAllVehicleDataByUserIdData,
  deleteVehicleRecordsDataUser,
  getAllSettlementListOfUserByIdData,
  getAllSettlementListOfUserByIdForGroupData,
  getSettlementDetailForGroupData,
  viewVehicleEditRecordData,
  saveResidencesData,
  getActivityLogData,
  changePasswordDataData,
  getAffiliateDetailByAffiliateKeyData,
  deleteResidencesUserData,
  viewResidencesDataApi,
  getPendingEligibilityQuestionApi,
  requestDismissSettlementApi,
  getFaqCategories,
  getAllFaqQuestion,
  getPageDetails,
  getUserByIdentityKeyApi,
  acceptDocumentUpdateByAdmin,
  planPriceUpdate,
  getDismissSettlementForUserApi,
  getAllAffiliateLinkForUserApi,
  saveSettlementWithoutDataApi,
  getAffiliateDashboardUserAPI,
  getAffiliateDashboardUserForParentAPI,
  getAllReferredUserByAffiliateIdData,
  getAllGroupsByParentAffiliateUserData,
  getAllPartnersByGroupData,
  getAllHierarchyChildAffiliateUsersByParentAffiliateUserData,
  getEnrolledListByAffiliateIdData,
  getEnrolledListBySearchAndFilterForGroupData,
  getEnrollForPartnerUserApi,
  getSettlementListForGroupApi,
  getBarGraphDataForDashboardData,
  getBarGraphDataForDashboardWithSettlementIdForParentUserData,
  getMonthlyEnrollmentsByAffiliateGroupData,
  getBarGraphDataForDashboardWithSettlementIdForParentUserForGroupData,
  getPieChartDataForDashboardData,
  getPieChartDataForStateDashboardData,
  moveToNextQuestionListApi,
  saveToNextQuestionListApi,
  getEligibilityQuestionByIdApi,
  saveMultipleVehicleDataApi,
  getAllNotificationsApi,
  markNotificationReadForUserApi,
  deleteNotificationApi,
  markNotificationApi,
  uploadChildCompany,
  getAllDashboardApi,
  getAllDashboardCountApi,
  GetAllAffiliateUsersByAffiliateTypeApi,
  getResourceSectionsAndLinksApi,
  getUserTransactionsHistoryApi,
  getDebitWalletBalanceApi,
  getAffiliateGroupApi,
  fusebillCreateCustomer,
  fusebillCreateCustomerBasic,
  fusebillSaveCardIdToDB,
  fusebillAddPaymentMethod,
  fusebillCountriesDataForCard
} from "../Api/api";
import { functions } from "lodash";
// worker Saga: will be fired on USER_FETCH_REQUESTED actions
/*function* getApiData(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(login, postData);
    // Check if the user role is business user---------
    if (data.userObject.userDto.roleName === 'Business-User'
        && data.userObject.planDto.planName !== 'Basic'
        && data.userObject.userDto.paymentStatus === 'pending'
        && data.userObject.userDto.fusebillCustomerId === null
    ) {
      const udata = {
        userId: data.userObject.userDto.userId,
        firstName: data.userObject.userDto.firstName,
        lastName: data.userObject.userDto.lastName,
        companyName: data.userObject.userDto.companyName,
        primaryEmail: data.userObject.userDto.primaryEmail,
      };
      const data2 = yield call(fusebillCreateCustomer, udata);
      yield all([
        put(receiveFuseBillData(data2)),
        put(receiveApiData(data)),
      ]);
    } else {
      yield put(receiveApiData(data));
    }
  } catch (e) {
    console.log(e);
  }
} */

function* getApiData(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(login, postData);
    // console.log('data', data)
    yield put(receiveApiData(data));
    yield put(receiveProfileApiData(data && data.userObject && data.userObject.userDto ? `${data.userObject.userDto.firstName} ${data.userObject.userDto.lastName}`: ""))
    localStorage.setItem("profileName", data && data.userObject && data.userObject.userDto ? `${data.userObject.userDto.firstName} ${data.userObject.userDto.lastName}`: "")
  } catch (e) {
    console.log(e);
  }
}

function* saveBusinessUser(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(businessUserSignUp, postData);
    // Signup user should be business user and
    // Plan should be basic.

    const udata = {
      customerInfo: {
        userId: data.result.userId,
        firstName: postData.firstName,
        lastName: postData.lastName,
        companyName: postData.companyName,
        primaryEmail: postData.email
      },
      billing: {
        companyName: postData.companyName,
        // line1: data.result.cardAddress,
        // city: data.result.cardCity,
        // postalZip: data.result.cardZipCode,

        line1: data.result.streeAddress,
        city: data.result.city,
        postalZip: data.result.zipCode,

        country: "USA",
        state: data.result.stateName
      }
    };

    if (
      postData.roleName === "Business-User" &&
      postData.selectedPlanName !== "Basic" &&
      postData.selectedPlanName !== "Basic Outsourced"
    ) {

      const data2 = yield call(fusebillCreateCustomer, udata);
      yield all([
        put(receiveFuseBillData(data2)),
        put(receiveSavedBusinessUser({ success: true }))
      ]);
    } else {

      yield call(fusebillCreateCustomerBasic, udata);

      yield put(receiveSavedBusinessUser({ success: true }));
    }
  } catch (e) {
    console.log(e);
  }
}

function* saveBusinessUserPartner(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(businessUserSignUpPartner, postData);
    // Signup user should be business user and
    // Plan should be basic.

    const udata = {
      customerInfo: {
        userId: data.result.userId,
        firstName: postData.firstName,
        lastName: postData.lastName,
        companyName: postData.companyName,
        primaryEmail: postData.email
      },
      billing: {
        companyName: postData.companyName,

        line1: postData.streeAddress,
        line2: postData.streeAddress2,
        city: postData.city,
        postalZip: postData.zipCode,
        country: "USA",
        state: data.result.stateName
      },
      postData: {
        postData
      },

    };

    if (
      postData.roleName === "Business-User" &&
      postData.selectedPlanName !== "Basic" &&
      postData.selectedPlanName !== "Basic Outsourced"
    ) {
      const data2 = yield call(fusebillCreateCustomer, udata);


      // const dataAddpayment = yield call(fusebillAddPaymentMethod, postDataAi);
      yield all([
        put(receiveFuseBillData(data2)),
        // put(receiveFusebillPaymentMethod(dataAddpayment)),
        put(receiveSavedBusinessUserPartner({ success: true }))
      ]);
    } else {
      yield call(fusebillCreateCustomerBasic, udata);

      yield put(receiveSavedBusinessUserPartner({ success: true }));
    }
  } catch (e) {
    console.log(e);
  }
}

function* getFusebillData(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(fusebillCreateCustomer, postData);
    yield put(receiveFuseBillData(data));
  } catch (e) {
    console.log(e);
  }
}

function* createFusebillCustomer(action) {
  try {
    const postData = action.data;
    const data = yield call(fusebillCreateCustomer, postData);
    yield put(receiveFuseBillData(data));
  } catch (e) {
    console.log(e);
  }
}

function* saveFusebillCardId(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(fusebillSaveCardIdToDB, postData);
    // yield put(receiveFuseBillData(data));
    yield put(receiveFusebillCardId(data));
  } catch (e) {
    console.log(e);
  }
}

function* addFusebillPaymentMethod(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(fusebillAddPaymentMethod, postData);
    yield put(receiveFusebillPaymentMethod(data));
  } catch (e) {
    console.log(e);
  }
}

function* getFusebillCountriesDataForCard(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(fusebillCountriesDataForCard, postData);
    yield put(receiveFusebillCountriesDataForCard(data));
  } catch (e) {
    console.log(e);
  }
}

// getAllSitePages
function* getAllSitePages(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAllSitePagesData, postData);
    yield put(receiveAllSitePages(data));
  } catch (e) {
    console.log(e);
  }
}

// getAffiliateData

function* getAffiliateData(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAffiliateDataUser, postData);
    yield put(receiveAffiliateUser(data));
  } catch (e) {
    console.log(e);
  }
}

// getAllVehicleMake
function* deleteVehicleRecordsData(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(deleteVehicleRecordsDataUser, postData);
    yield put(receivedeleteVehicleRecordsData(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllSettlementListOfUserById(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAllSettlementListOfUserByIdData, postData);
    yield put(receiveAllSettlementListOfUserById(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllSettlementListOfUserByIdForGroup(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAllSettlementListOfUserByIdForGroupData, postData);
    yield put(receiveAllSettlementListOfUserByIdForGroup(data));
  } catch (e) {
    console.log(e);
  }
}

function* getSettlementDetailForGroup(action) {
  try {
    console.log("hihihihihihhhihihihiihhi")
    // do api call
    const postData = action.data;
    console.log('postData================', postData)
    const data = yield call(getSettlementDetailForGroupData, postData);
    yield put(receiveGetSettlementDetailForGroup(data));
  } catch (e) {
    console.log(e);
  }
}

// viewVehicleEditRecord

function* viewVehicleEditRecord(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(viewVehicleEditRecordData, postData);
    yield put(receiveViewVehicleEditRecord(data));
  } catch (e) {
    console.log(e);
  }
}

// SAVE

function* saveResidences(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(saveResidencesData, postData);
    yield put(receivesaveResidences(data));
  } catch (e) {
    console.log(e);
  }
}

// Activity Log
function* getActivityLog(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getActivityLogData, postData);
    yield put(receiveActivityLog(data));
  } catch (e) {
    console.log(e);
  }
}

// changePasswordData
function* changePasswordData(action) {
  try {
    // do api call
    const postData = action.data;
    const rep = yield call(changePasswordDataData, postData);
    yield put(receiveChangePasswordData(rep));
  } catch (e) {
    // console.log(e);
  }
}
// getAffiliateDetailByAffiliateKey
function* getAffiliateDetailByAffiliateKey(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAffiliateDetailByAffiliateKeyData, postData);
    yield put(receiveAffiliateDetailByAffiliateKey(data));
  } catch (e) {
    console.log(e);
  }
}

//
// function* submitSubUser(action) {
//  try {
//     // do api call
//     let postData = action.data;
//     const resp = yield call(saveAffilateSubUserSignUp, postData);
//     console.log("test resp ",resp)
//     //const resp =  yield put(receiveAffiliateSubUser(data));
//      //console.log("aws rest",data)

//      const dataServer = yield call(saveAffilateSubUserSignUpServer, postData, resp);
//      console.log("dataServer",dataServer)
//      const rest =  yield put(receiveAffiliateSubUser(dataServer));
//      console.log("res data",rest)
//   } catch (e) {
//     console.log(e);
//   }
// }

// getAllVehicleMake
function* getAllVehicleMake(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAllVehicleMakeData, postData);
    yield put(receiveAllVehicleMake(data));
  } catch (e) {
    console.log(e);
  }
}
// getAllVehicleDataByUserId
function* getAllVehicleDataByUserIdInfo(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAllVehicleDataByUserIdData, postData);
    yield put(receiveAllVehicleDataByUserId(data));
  } catch (e) {
    console.log(e);
  }
}

// getAllVehicleModel
function* getAllVehicleModel(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAllVehicleModelData, postData);
    yield put(receiveAllVehicleModel(data));
  } catch (e) {
    console.log(e);
  }
}
// getAllVehicleYear

function* getAllVehicleYear(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAllVehicleYearData, postData);
    yield put(receiveAllVehicleYear(data));
  } catch (e) {
    console.log(e);
  }
}

// getExternalVehicleDataById
function* getExternalVehicleDataById(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getExternalVehicleDataByIdData, postData);
    yield put(receiveExternalVehicleDataById(data));
  } catch (e) {
    console.log(e);
  }
}
// getTotalFundSettlement
function* getTotalFundSettlement(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getTotalFundSettlementData, postData);
    yield put(receiveTotalFundSettlement(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllCountry(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAllCountryData, postData);
    yield put(receiveAllCountry(data));
  } catch (e) {
    console.log(e);
  }
}

function* disbursePayment(action) {
  try{
    const postData = action.data;
    const data = yield call(getDisbursePayment, postData);
    yield put(receiveDisbursePayment(data));
  } catch(e) {
    console.log(e)
  }
}

function* transferFundsToACH(action) {
  try{
    const postData = action.data;
    const data = yield call(getTransferFundsToACH, postData);
    yield put(receiveTransferFundsToACH(data));
  } catch(e) {
    console.log(e)
  }
}

function* transferFundsToCard(action) {
  try{
    const postData = action.data;
    const data = yield call(getTransferFundsToCard, postData);
    yield put(receiveTransferFundsToCard(data));
  } catch(e) {
    console.log(e)
  }
}

function* getTranscardPaymentMethods(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getTranscardPaymentMethodsApi, postData);
    yield put(receiveAllPaymentMethods(data));
  } catch (e) {
    console.log(e);
  }
}

function* uploadFile(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(saveUploadFile, postData);
    yield put(receiveSavedUploadFile(data));
  } catch (e) {
    console.log(e);
  }
}
function* uploadsEligibilityQuestionFileByUser(action){
  try {
    // do api call
    const postData = action.data;
    console.log("postData",postData)
    const data = yield call(saveUploadEligibilityQuestionFileByUser, postData);
    yield put(receieveUploadEligibilityQuestionFileByUser(data));
  } catch (e) {
    console.log(e);
  }
}


function* deletesEligibilityQuestionFileByUser(action){
  try {
    // do api call
    const postData = action.data;
    console.log("postData",postData)
    const data = yield call(saveDeleteUploadEligibilityQuestionFileByUser, postData);
    yield put(receiveDeleteEligibilityQuestionFileByUser(data));
  } catch (e) {
    console.log(e);
  }
}
function* updateUserSignatureWithDocs(action) {
  try {
    // do api call
    const postData = action.data;
    yield call(updateUserSignatureWithDocsApi, postData);
    yield put(receiveSavedUploadFileDoc({ success: true }));
  } catch (e) {
    console.log(e);
  }
}

function* saveConsumerUser(action) {
  try {
    // do api call
    const postData = action.data;
    yield call(saveConsumerUserSignUp, postData);
    yield put(receiveSavedConsumerUser({ success: true }));
  } catch (e) {
    console.log(e);
  }
}

function* getBusinessUser(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getBusinessUserProfile, postData);
    yield put(receiveBusinessUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getNotificationLogUnReadCountForUser(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getNotificationLogUnReadCountForUserApi, postData);
    yield put(receiveNotificationLogUnReadCountForUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getBusinessUserAffilate(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getBusinessUserProfile, postData);
    yield put(receiveBusinessUserAffilate(data));
  } catch (e) {
    console.log(e);
  }
}

function* viewCompanyChildRecord(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(viewCompanyChildRecordSave, postData);
    yield put(receiveViewCompanyChildRecord(data));
  } catch (e) {
    console.log(e);
  }
}

function* getConsumerUser(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getConsumerUserProfile, postData);
    yield put(receiveConsumerUser(data));
  } catch (e) {
    console.log(e);
  }
}


function* getAutoUpdateUser(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAutoUpdateUserApi, postData);
    yield put(receiveUpdateAutoSettlementFlag(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllChildCompanyProfile(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(getAllChildCompanyProfileData, postData);
    console.log(data);
    yield put(receiveChildCompanyProfile(data));
  } catch (e) {
    console.log(e);
  }
}

// getAllChildCompanyProfileUpdate

// function* getAllChildCompanyProfileUpdate(action) {
//   try {
//     // do api call
//     let postData = action.data;
//     const data = yield call(getAllChildCompanyProfileUpdateData, postData);
//     yield put(receiveChildCompanyProfileUpdate(data));
//   } catch (e) {
//     console.log(e);
//   }
// }

function* saveBusinessUserStep1(action) {
  try {
    // do api call
    const postData = action.data;
    yield put(receiveSavedBusinessUserStep1({ step1: postData }));
  } catch (e) {
    console.log(e);
  }
}

function* clearBusinessData() {
  try {
    yield put(receiveClearSignupData());
  } catch (e) {
    console.log(e);
  }
}

function* updateBusinessCompany(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(updateBusinessCompanySave, postData);
    yield put(receiveUpdateBusinessCompany(data));
  } catch (e) {
    console.log(e);
  }
}

function* updateConsumerUserData(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(updateConsumerUser, postData);
    yield put(receiveUpdateConsumerUser(data));
  } catch (e) {
    console.log(e);
  }
}


function* createTranscardAccountData(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(createTranscardAccountApi, postData);
    yield put(receiveTranscardAccountApi(data));
  } catch (e) {
    console.log(e);
  }
}

function* createTranscardCardData(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(createTranscardCardApi, postData);
    yield put(receiveTranscardCardApi(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAddedBankAccountsForUser(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(getAddedBankAccountsForUserApi, postData);
    yield put(receiveGetAddedBankAccountsForUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAddedCardsForUser(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(getAddedCardsForUserApi, postData);
    yield put(receiveGetAddedCardsForUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getCollectedSettlementsHistoryForUser(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(getCollectedSettlementsHistoryForUserApi, postData);
    yield put(receiveGetCollectedSettlementsHistoryForUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllBankAccountsForUser(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(getAllBankAccountsForUserApi, postData);
    yield put(receiveGetAllBankAccountsForUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllAddedCardsForUser(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(getAllAddedCardsForUserApi, postData);
    yield put(receiveGetAllAddedCardsForUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getUserTransactionsHistory(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(getUserTransactionsHistoryApi, postData);
    yield put(receiveGetUserTransactionsHistory(data));
  } catch (e) {
    console.log(e);
  }
}

function* showNetAmountToUser(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(showNetAmountToUserApi, postData);
    yield put(receiveShowNetAmountToUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* setDefaultBankAccount(action) {
  try{
    const postData = action.data

    const data = yield call(setDefaultBankAccountApi, postData);
    yield put(receiveSetDefaultBankAccount(data));
  } catch (e) {
    console.log(e);
  }
}

function* setDefaultCard(action) {
  try{
    const postData = action.data

    const data = yield call(setDefaultCardApi, postData);
    yield put(receiveSetDefaultCard(data));
  } catch (e) {
    console.log(e);
  }
}

function* addUserCard(action) {
  try{
    const postData = action.data

    const data = yield call(addUserCardApi, postData);
    yield put(receiveAddUserCard(data));
  } catch (e) {
    console.log(e);
  }
}

function* addBusinessUserCard(action) {
  try{
    const postData = action.data

    const data = yield call(addBusinessUserCardApi, postData);
    yield put(receiveAddBusinessUserCard(data));
  } catch (e) {
    console.log(e);
  }
}

function* deleteUserBankAccount(action) {
  try{
    const postData = action.data

    const data = yield call(deleteUserBankAccountApi, postData);
    yield put(receiveDeleteUserBankAccount(data));
  } catch (e) {
    console.log(e);
  }
}

function* deleteUserCard(action) {
  try{
    const postData = action.data

    const data = yield call(deleteUserCardApi, postData);
    yield put(receiveDeleteUserCard(data));
  } catch (e) {
    console.log(e);
  }
}

function* addUserBankAccountData(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(addUserBankAccountApi, postData);
    yield put(receiveAddUserBankAccountApi(data));
  } catch (e) {
    console.log(e);
  }
}

function* updateBankAccountDetails(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(updateBankAccountDetailsApi, postData);
    yield put(receiveUpdateBankAccountDetails(data));
  } catch (e) {
    console.log(e);
  }
}

function* updateCardDetails(action) {
  try {
    // do api call
    const postData = action.data;

    const data = yield call(updateCardDetailsApi, postData);
    yield put(receiveUpdateCardDetails(data));
  } catch (e) {
    console.log(e);
  }
}

// getAutoPartDefendentPartsByPartId

function* getAutoPartDefendentPartsByPartId(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAutoPartDefendentPartsByPartIdApi, postData);
    yield put(receiveAutoPartDefendentPartsByPartId(data));
  } catch (e) {
    console.log(e);
  }
}

// saveUsersUneligibleSettlements

function* saveUsersUneligibleSettlements(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(saveUsersUneligibleSettlementsApi, postData);
    yield put(receiveUsersUneligibleSettlements(data));
  } catch (e) {
    console.log(e);
  }
}

function* updateBusinessUserData(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(updateBusinessUser, postData);
    yield put(receiveUpdateBusinessUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllState(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllStates, postData);
    yield put(receiveAllStates(data));
  } catch (e) {
    console.log(e);
  }
}

function* requestForgetPassword(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(changeForgetPassword, postData);
    yield put(receiveForgetPasswordData(data));
  } catch (e) {
    console.log(e);
  }
}

function* requestAllPlans(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllPlans, postData);
    yield put(receiveAllPlans(data));
  } catch (e) {
    console.log(e);
  }
}

function* confirmUserEmail(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(ConfirmCodeApi, postData);
    yield put(receiveconfirmUserEmail(data));
  } catch (e) {
    console.log(e);
  }
}

function* restUserPassword(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(resetPassword, postData);
    yield put(receiveResetPassword(data));
  } catch (e) {
    console.log(e);
  }
}

function* getBusinessList(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getForBusinessAndIndustry, postData);
    yield put(receiveBusiness(data));
  } catch (e) {
    console.log(e);
  }
}

function* getIndustryList(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getForBusinessAndIndustry, postData);
    yield put(receiveIndustry(data));
  } catch (e) {
    console.log(e);
  }
}

function* SettlemetEnrichmentQuestion(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(SettlemetEnrichmentQuestionApi, postData);
    yield put(receiveSettlemetEnrichmentQuestion(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllSettlement(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllSettlementApi, postData);
    yield put(receiveAllSettlement(data));
  } catch (e) {
    console.log(e);
  }
}
// getPromotedSettlementByUserId
function* getPromotedSettlementByUserId(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getPromotedSettlementByUserIdData, postData);
    yield put(receivePromotedSettlementByUserId(data));
  } catch (e) {
    console.log(e);
  }
}
function* getAllFilteredSettlement(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllFilteredSettlementApi, postData);
    yield put(receiveAllFilteredSettlement(data));
  } catch (e) {
    console.log(e);
  }
}
// getAllFilteredDSettlement
function* getAllFilteredDSettlement(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllFilteredDSettlementApi, postData);
    yield put(receiveAllDFilteredSettlement(data));
  } catch (e) {
    console.log(e);
  }
}

// getAllReferredUserByAffiliateId
function* getAllReferredUserByAffiliateId(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllReferredUserByAffiliateIdData, postData);
    yield put(receiveAllReferredUserByAffiliateId(data));
  } catch (e) {
    console.log(e);
  }
}

// getAllGroupsByParentAffiliateUser
function* getAllGroupsByParentAffiliateUser(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllGroupsByParentAffiliateUserData, postData);
    yield put(receiveAllGroupsByParentAffiliateUser(data));
  } catch (e) {
    console.log(e);
  }
}

// getAllPartnersByGroup
function* getAllPartnersByGroup(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllPartnersByGroupData, postData);
    yield put(receiveAllPartnerByGroup(data));
  } catch (e) {
    console.log(e);
  }
}

//getAllHierarchyChildAffiliateUsersByParentAffiliateUser
function* getAllHierarchyChildAffiliateUsersByParentAffiliateUser(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllHierarchyChildAffiliateUsersByParentAffiliateUserData, postData);
    yield put(receiveAllHierarchyChildAffiliateUsersByParentAffiliateUser(data));
  } catch (e) {
    console.log(e);
  }
}

// getEnrolledListByAffiliateId

function* getEnrolledListByAffiliateId(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getEnrolledListByAffiliateIdData, postData);
    yield put(receiveEnrolledListByAffiliateId(data));
  } catch (e) {
    console.log(e);
  }
}

function* getEnrolledListBySearchAndFilterForGroup(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getEnrolledListBySearchAndFilterForGroupData, postData);
    yield put(receiveGetEnrolledListBySearchAndFilterForGroup(data));
  } catch (e) {
    console.log(e);
  }
}

// getEnrollForPartnerUser

function* getEnrollForPartnerUser(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getEnrollForPartnerUserApi, postData);
    yield put(receiveEnrollForPartnerUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getSettlementListForGroup(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getSettlementListForGroupApi, postData);
    yield put(receiveGetSettlementListForGroup(data));
  } catch (e) {
    console.log(e);
  }
}


function* getSettlementListByAffiliateType(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getSettlementListByAffiliateTypeData, postData);
    yield put(receiveSettlementListByAffiliateType(data));
    yield put(receiveSuccess(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllEnrolledSettlement(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllEnrolledSettlementApi, postData);
    yield put(receiveAllEnrolledSettlement(data));
  } catch (e) {
    console.log(e);
  }
}
function* getAllCategory(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllCategoryAPI, postData);
    yield put(receiveAllCategory(data));
  } catch (e) {
    console.log(e);
  }
}

function* getEnrollSettlementForUser(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getEnrollSettlementForUserApi, postData);
    yield put(receiveEnrollSettlementForUser(data));
  } catch (e) {
    console.log(e);
  }
}
function* getAttentionSettlementForUser(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAttentionSettlementForUserApi, postData);
    yield put(receiveAttentionSettlementForUser(data));
  } catch (e) {
    console.log(e);
  }
}
function* getCompleteSettlementForUser(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getCompleteSettlementForUserApi, postData);
    yield put(receiveCompleteSettlementForUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAlLFeatureSettlement(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAlLFeatureSettlementApi, postData);
    yield put(receiveAlLFeatureSettlement(data));
  } catch (e) {
    console.log(e);
  }
}

function* saveEnrichmentQuestionAnsers(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(saveEnrichmentQuestionAnswerApi, postData);
    yield put(receiveEnrichmentAnswer(data));
  } catch (e) {
    console.log(e);
  }
}

function* receiveGetSagasSettlementById(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getSettlementById, postData);
    yield put(receiveGetSettlementById(data));
  } catch (e) {
    console.log(e);
  }
}

function* getCognitoIdByEmail(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getCognitoIdByEmailOfUser, postData);
    console.log(["data", data]);
    yield put(receiveCognitoIdByEmail(data));
  } catch (e) {
    console.log(e);
  }
}

function* confirmCognitoUserEmail(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(ConfirmUserCodeApi, postData);
    yield put(receiveconfirmCognitoUserEmail(data));
  } catch (e) {
    console.log(e);
  }
}

function* updateBusinessCompanyData(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(updateBusinessCompanyDataSave, postData);
    yield put(receiveUpdateBusinessCompanyData(data));
  } catch (e) {
    console.log(e);
  }
}

function* deleteCompanyChildRecord(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(deleteCompanyChildRecordSave, postData);
    yield put(receiveDeleteCompanyChildRecord(data));
  } catch (e) {
    console.log(e);
  }
}

function* getState(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getStateData, postData);
    yield put(receiveGetState(data));
  } catch (e) {
    console.log(e);
  }
}

function* submitSubUser(action) {
  try {
    // do api call
    const postData = action.data;
    const resp = yield call(saveAffilateSubUserSignUp, postData);
    console.log("test resp ", resp);
    // const resp =  yield put(receiveAffiliateSubUser(data));
    // console.log("aws rest",data)

    const dataServer = yield call(
      saveAffilateSubUserSignUpServer,
      postData,
      resp
    );
    console.log("dataServer", dataServer);
    const rest = yield put(receiveAffiliateSubUser(dataServer));
    console.log("res data", rest);
  } catch (e) {
    console.log(e);
  }
}
function* submitSubUserBusiness(action) {
  try {
    // do api call
    const postData = action.data;
    const resp = yield call(saveBusinessSubUserSignUp, postData);
    console.log("test resp ", resp);
    // const resp =  yield put(receiveAffiliateSubUser(data));
    // console.log("aws rest",data)

    const dataServer = yield call(
      saveBusinessSubUserSignUpServer,
      postData,
      resp
    );
    console.log("dataServer", dataServer);
    const rest = yield put(receiveBusinessSubUser(dataServer));
    console.log("res data", rest);
  } catch (e) {
    console.log(e);
  }
}

function* getAllAffiliatedUsers(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getAffliliateUsers, postData);
    yield put(receiveAllAffiliatedUsers(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllBusinessSubUsers(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getBusinesssSubUsers, postData);
    yield put(receiveAllBusinessSubUsers(data));
  } catch (e) {
    console.log(e);
  }
}

function* deleteAllAffiliatedUsers(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(deteteAffliliateUsers, postData);
    yield put(receiveDeleteAffiliatedSubUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* deleteBusinessSubUser(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(deteteBusinessUsers, postData);
    yield put(receiveDeleteBusinessSubUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getCityByStateId(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getCityByStateIdData, postData);
    yield put(receiveGetCity(data));
  } catch (e) {
    console.log(e);
  }
}

function* getUpdateAffiliateUser(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(getUpdateAffiliateUserData, postData);
    yield put(receiveUpdateAffiliateUser(data));
    yield put(receiveProfileApiData(postData  ? `${postData.firstName} ${postData.lastName}`: ""))
    localStorage.setItem("profileName", postData  ? `${postData.firstName} ${postData.lastName}`: "")

  } catch (e) {
    console.log(e);
  }
}

function* requestAllPlansConsumer(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllPlansConsumer, postData);
    yield put(receiveAllPlansConsumer(data));
  } catch (e) {
    console.log(e);
  }
}

function* saveSettlementAnswers(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(saveSettlementAnswersResponse, postData);
    yield put(receiveSettlementAnswers(data));
  } catch (e) {
    console.log(e);
  }
}

function* saveEnrollmenttDocTOdB(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(uploadEnrolmentDoc, postData);
    yield put(receiveEnrollmenttDoc(data));
  } catch (e) {
    console.log(e);
  }
}

function* updateEnrollmenttDocTOdB(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(updateUploadEnrolmentDoc, postData);
    yield put(receiveUpdateEnrollmenttDoc(data));
  } catch (e) {
    console.log(e);
  }
}
function* checkEmailVerify(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(emailVeriy, postData);
    yield put(receivecheckEmailVerify(data));
  } catch (e) {
    console.log(e);
  }
}
function* getAffiliateUserType(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAffiliateType, postData);
    yield put(receiveAffiliateUserType(data));
  } catch (e) {
    console.log(e);
  }
}
function* getAffiliateSubUserById(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAffiliateSubUserDataById, postData);
    yield put(receiveAffiliateSubUserById(data));
  } catch (e) {
    console.log(e);
  }
}
function* getBusinessSubUserById(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getBusinessSubUserDataById, postData);
    yield put(receiveBusinessSubUserById(data));
  } catch (e) {
    console.log(e);
  }
}
function* UpdateAffiliateSubUser(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(updateAffiliateSubUserData, postData);
    yield put(receiveUpdateAffiliateSubUser(data));

    if(postData && postData.data && postData.data.isprofileStatus) {
      yield put(receiveProfileApiData(postData && postData.data ? `${postData.data.firstname} ${postData.data.lastname}`: ""))
      localStorage.setItem("profileName", postData && postData.data ? `${postData.data.firstname} ${postData.data.lastname}`: "")
    }

  } catch (e) {
    console.log(e);
  }
}
function* UpdateBusinessSubUser(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(updateBusinessSubUserData, postData);
    yield put(receiveUpdateBusinessSubUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* saveEnrollmentAuthorization(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(enrollmentAuthorizationApi, postData);
    yield put(receiveEnrollmentAuthorization(data));
  } catch (e) {
    console.log(e);
  }
}

function* saveCompletedSettlements(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getEnrollSettlementForUserApi, postData);
    yield put(receiveCompletedSettlements(data));
  } catch (e) {
    console.log(e);
  }
}

function* getConsumerResidenceListing(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllUserResidenceByUserId, postData);
    yield put(receiveConsumerResidence(data));
  } catch (e) {
    console.log(e);
  }
}

function* getPendingRequiredDoc(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getPendingRequiredDocApi, postData);
    yield put(receivePendingRequiredDoc(data));
  } catch (e) {
    console.log(e);
  }
}

// getPendingRequiredDocUser
function* getPendingRequiredDocUser(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getPendingRequiredDocUserApi, postData);
    yield put(receivePendingRequiredDocUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getPendingRequiredDocUserDelete(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getPendingRequiredDocUserDeleteApi, postData);
    yield put(receivePendingRequiredDocUserDelete(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllVehicleDataByUserId(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllVehicleDataByUserIdAPI, postData);
    yield put(receiveAllVehicleDataByUserIdAPI(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllVehicleDataByUserIdSettelment(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllVehicleDataSettlementByUserIdAPI, postData);
    yield put(receiveAllVehicleDataSettlementByUserIdAPI(data));
  } catch (e) {
    console.log(e);
  }
}

function* saveMultipleVehicleDataByUserIdAPI(action) {
  try {
    // do api call
    const postData = action.data;
    const data = yield call(saveMultipleVehicleDataByUserIdAPIList, postData);
    yield put(receivesaveMultipleVehicleDataByUserIdAPI(data));
  } catch (e) {
    console.log(e);
  }
}

function* deleteResidencesData(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(deleteResidencesUserData, postData);
    yield put(receivedeleteConsumerResidence(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllVehicleTrim(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllVehicleTrimData, postData);
    yield put(receivegetAllVehicleTrim(data));
  } catch (e) {
    console.log(e);
  }
}

function* addVehicleData(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(saveVehicleData, postData);
    yield put(receiveAddVehicleData(data));
  } catch (e) {
    console.log(e);
  }
}

function* addVehicleDataClear(action) {
  try {
    // do api call
    const data = {};
    yield put(receiveAddVehicleData(data));
    yield put(receiveViewVehicleEditRecord(data))
  } catch (e) {
    console.log(e);
  }
}

function* viewResidencesData(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(viewResidencesDataApi, postData);
    yield put(receiveviewConsumerResidence(data));
  } catch (e) {
    console.log(e);
  }
}

function* getPendingsettlementQuestion(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getPendingEligibilityQuestionApi, postData);
    yield put(receivePendingSettlementQuestions(data));
  } catch (e) {
    console.log(e);
  }
}

function* requestDismissSettlement(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(requestDismissSettlementApi, postData);
    yield put(receiveDismissSettlement(data));
  } catch (e) {
    console.log(e);
  }
}

function* getFaqCategory(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getFaqCategories, postData);
    yield put(receiveFaqCategory(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllFaqQuestionBYCategoryId(action) {
  try {
    const postData = action;
    const data = yield call(getAllFaqQuestion, postData);
    yield put(receiveFaqQuestionBYCategoryId(data));
  } catch (e) {
    console.log(e);
  }
}

function* getPageData(action) {
  try {
    const postData = action;
    const data = yield call(getPageDetails, postData);
    yield put(receivePageData(data));
  } catch (e) {
    console.log(e);
  }
}

function* getPageDataFooter(action) {
  try {
    const postData = action;
    const data = yield call(getPageDetails, postData);
    yield put(receivePageDataFooter(data));
  } catch (e) {
    console.log(e);
  }
}

function* getUserByIdentityKey(action) {
  try {
    const postData = action;
    const data = yield call(getUserByIdentityKeyApi, postData);
    yield put(receiveUserByIdentityKey(data));
  } catch (e) {
    console.log(e);
  }
}

function* handleAcceptedService(action) {
  try {
    const postData = action;
    const data = yield call(acceptDocumentUpdateByAdmin, postData);
    yield put(receiveAcceptDocumentUpdateByAdmin(data));
  } catch (e) {
    console.log(e);
  }
}

// clearData
function* clearServiceData() {
  try {
    // do api call
    const data = [];
    yield put(receiveAcceptDocumentUpdateByAdmin(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAffiliateDashboardUserAction(action) {
  try {
    const postData = action;
    const data = yield call(getAffiliateDashboardUserAPI, postData);
    yield put(receiveAffiliateDashboardUserAction(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAffiliateDashboardUserForParent(action) {
  try {
    const postData = action;
    const data = yield call(getAffiliateDashboardUserForParentAPI, postData);
    yield put(receiveGetAffiliateDashboardUserForParent(data));
  } catch (e) {
    console.log(e);
  }
}

// getBarGraphDataForDashboard
function* getBarGraphDataForDashboard(action) {
  try {
    const postData = action;
    const data = yield call(getBarGraphDataForDashboardData, postData);
    yield put(receiveBarGraphDataForDashboard(data));
  } catch (e) {
    console.log(e);
  }
}

function* getBarGraphDataForDashboardWithSettlementIdForParentUser(action) {
  try {
    const postData = action;
    const data = yield call(getBarGraphDataForDashboardWithSettlementIdForParentUserData, postData);
    yield put(receiveGetBarGraphDataForDashboardWithSettlementIdForParentUser(data));
  } catch (e) {
    console.log(e);
  }
}
function* getMonthlyEnrollmentsByAffiliateGroup(action) {
  try {
    const postData = action;
    const data = yield call(getMonthlyEnrollmentsByAffiliateGroupData, postData);
    yield put(receiveMonthlyEnrollmentsByAffiliateGroup(data));
  } catch (e) {
    console.log(e);
  }
}
function* getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup(action) {
  try {
    const postData = action;
    const data = yield call(getBarGraphDataForDashboardWithSettlementIdForParentUserForGroupData, postData);
    yield put(receiveGetBarGraphDataForDashboardWithSettlementIdForParentUserForGroup(data));
  } catch (e) {
    console.log(e);
  }
}

function* getPieChartDataForDashboard(action) {
  try {
    const postData = action;
    const data = yield call(getPieChartDataForDashboardData, postData);
    yield put(receivePieChartDataForDashboard(data));
  } catch (e) {
    console.log(e);
  }
}

function* getPieChartDataForStateDashboard(action) {
  try {
    const postData = action;
    const data = yield call(getPieChartDataForStateDashboardData, postData);
    yield put(receivePieChartDataForStateDashboard(data));
  } catch (e) {
    console.log(e);
  }
}

function* planPriceChange(action) {
  try {
    const postData = action;
    const data = yield call(planPriceUpdate, postData);
    yield put(receivePlanPriceChange(data));
  } catch (e) {
    console.log(e);
  }
}

function* clearPlanData() {
  try {
    const data = {}
    yield put(receivePlanPriceChange(data));
  } catch (e) {
    console.log(e);
  }
}


function* getDismissSettlementForUser(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getDismissSettlementForUserApi, postData);
    yield put(receiveDismissSettlementForUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllAffiliateLink(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getAllAffiliateLinkForUserApi, postData);
    yield put(receiveAllAffiliateLinkAction(data));
  } catch (e) {
    console.log(e);
  }
}

function* saveSettlementWithoutDataSagas(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(saveSettlementWithoutDataApi, postData);
    yield put(receiveSettlementWithoutData(data));
  } catch (e) {
    console.log(e);
  }
}

// moveToNextQuestionList
function* moveToNextQuestionList(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(moveToNextQuestionListApi, postData);

    if (data.settlementId !== undefined && data.settlementId !== "") {
      const dataList = yield call(
        getAllVehicleDataSettlementByUserIdAPI,
        postData
      );
      yield put(receiveAllVehicleDataSettlementByUserIdAPI(dataList));
    }

    yield put(receiveMoveToNextQuestionList(data));
  } catch (e) {
    console.log(e);
  }
}

// clearData
function* clearData() {
  try {
    // do api call
    const data = ["false"];
    yield put(receiveMoveToNextQuestion(data));
    yield put(receiveMoveToSaveQuestion(data));
    yield put(receiveClearAffilate(data));
  } catch (e) {
    console.log(e);
  }
}
// clearData
function* clearDataChange() {
  try {
    // do api call
    const data = [];
    yield put(receiveChangePassword(data));
  } catch (e) {
    console.log(e);
  }
}

// clearData
function* clearDataEnrollment() {
  try {
    // do api call
    const data = [];
    yield put(receiveAllEnrolledSettlement(data));
  } catch (e) {
    console.log(e);
  }
}

// clearDataSettlmentanswers
function* clearDataSettlmentanswers() {
  try {
    // do api call
    const data = [];
    yield put(receiveDataSettlmentanswers(data));
  } catch (e) {
    console.log(e);
  }
}
// clearDataEmail

function* clearDataEmail() {
  try {
    // do api call
    const data = [];
    yield put(receivecheckEmailVerifyData(data));
  } catch (e) {
    console.log(e);
  }
}

function* RecieveConsumerUserDataClear() {
  try {
    // do api call
    yield put(RecieveConsumerUserDataClearData());
  } catch (e) {
    console.log(e);
  }
}

function* RecieveBussnessUserDataClear() {
  try {
    // do api call
    yield put(RecieveBussnessUserDataClearData());
  } catch (e) {
    console.log(e);
  }
}

function* saveToNextQuestionList(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(saveToNextQuestionListApi, postData);
    if (data.settlementId !== undefined && data.settlementId !== "") {
      const dataList = yield call(
        getAllVehicleDataSettlementByUserIdAPI,
        postData
      );
      yield put(receiveAllVehicleDataSettlementByUserIdAPI(dataList));
      yield put(receiveSaveMoveToNextQuestionList(data));
    }
  } catch (e) {
    console.log(e);
  }
}

function* getEligibilityQuestionById(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(getEligibilityQuestionByIdApi, postData);
    yield put(receiveEligibilityQuestionById(data));
  } catch (e) {
    console.log(e);
  }
}

// saveMultipleVehicleData
function* saveMultipleVehicleData(action) {
  try {
    // do api call
    const postData = action;
    const data = yield call(saveMultipleVehicleDataApi, postData);
    yield put(receiveMultipleVehicleData(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllNotifications(action) {
  try {
    const data = yield call(getAllNotificationsApi, action.data);
    yield put(recieveAllNotifications(data));
  } catch (e) {
    console.log(e);
  }
}

function* markNotificationReadForUser(action) {
  try {
    const data = yield call(markNotificationReadForUserApi, action.data);
    yield put(recievemarkNotificationReadForUser(data));
  } catch (e) {
    console.log(e);
  }
}

function* deleteNotification(action) {
  try {
    const data = yield call(deleteNotificationApi, action.data);
    yield put(deleteNotificationSuccess(data));
  } catch (e) {
    console.log(e);
  }
}

function* markAllReadNotification(action) {
  try {
    const data = yield call(markNotificationApi, action.data);
    yield put(markNotificationSuccess(data));
  } catch (e) {
    console.log(e);
  }
}

function* uploadChildCompnayCsv(action) {
  try {
    const data = yield call(uploadChildCompany, action.data);
    yield put(receiveUploadedChildComapny(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllDashboardSaga(action) {
  try {
    const data = yield call(getAllDashboardApi, action.data);
    yield put(receiveAllDashboard(data));
  } catch (e) {
    console.log(e);
  }
}

function* getAllDashboardCountSaga(action) {
  try {
    const data = yield call(getAllDashboardCountApi, action.data);
    yield put(receiveAllDashboardCount(data));
  } catch (e) {
    console.log(e);
  }
}

function* GetAllAffiliateUsersByAffiliateType(action) {
  try {
    const data = yield call(GetAllAffiliateUsersByAffiliateTypeApi, action.data);
    yield put(receiveAllAffiliateUsersByAffiliateType(data));
  } catch (e) {
    console.log(e);
  }
}



function* getResourceSectionsAndLinks(action) {
  try {
    const { data } = yield call(getResourceSectionsAndLinksApi, action.data);
    yield put(receivetResourceSectionsAndLinks(data));
  } catch (e) {
    console.log(e);
  }
}

function* getDebitWalletBalance(action) {
  try {
    const data  = yield call(getDebitWalletBalanceApi, action.data);
    yield put(receivetDebitWalletBalance(data));
    const data3 = yield call(getBusinessUserProfile, action.data.userId);
       yield put(receiveBusinessUser(data3));
    if(action.data.roleName === "Business-User") {
      const data3 = yield call(getBusinessUserProfile, action.data.userId);
       yield put(receiveBusinessUser(data3));
    }
    else {
      const data2 = yield call(getConsumerUserProfile, action.data.userId);
      yield put(receiveConsumerUser(data2));
      }
  } catch (e) {
    console.log(e);
  }
}



function* getAffiliateGroup(action) {
  try {
    console.log("datarez",action.data)
    const { data } = yield call(getAffiliateGroupApi, action.data);
    yield put(receiveGetAffiliateGroup(data));
  } catch (e) {
    console.log(e);
  }
}


/*
  Alternatively you may use takeLatest.

  Does not allow concurrent fetches of user. If "USER_FETCH_REQUESTED" gets
  dispatched while a fetch is already pending, that pending fetch is cancelled
  and only the latest one will be run.
*/
export default function* mySaga() {
  yield takeLatest(REQUEST_API_DATA, getApiData);
  yield takeLatest(REQUEST_FUSEBILL_DATA, getFusebillData);
  yield takeLatest(REQUEST_CREATE_FUSEBILL_CUSTOMER, createFusebillCustomer);
  yield takeLatest(REQUEST_SAVE_FUSEBILL_CARD_ID, saveFusebillCardId);
  yield takeLatest(
    REQUEST_SAVE_FUSEBILL_PAYMENT_METHOD,
    addFusebillPaymentMethod
  );
  yield takeLatest(
    REQUEST_FUSEBILL_COUNTRIES_DATA_FOR_CARD,
    getFusebillCountriesDataForCard
  );
  yield takeLatest(GET_ALL_SITE, getAllSitePages);
  yield takeLatest(VIEW_CONSUMER_RESIDENCE, viewResidencesData);
  yield takeLatest(REQUEST_STATEID_DATA, getState);
  yield takeLatest(REQUEST_CITYID_DATA, getCityByStateId);
  yield takeLatest(REQUEST_UPDATE_AFFILIATE_DATA, getUpdateAffiliateUser);
  yield takeLatest(REQUEST_AFFILIATE_DATA, getAffiliateData);
  yield takeLatest(GET_ALL_VEHICLE_YEAR, getAllVehicleYear);
  yield takeLatest(GET_ALL_EXTERNAL_VEHICLE_DATA, getExternalVehicleDataById);
  yield takeLatest(GET_ALL_TOTAL_FUND_DATA, getTotalFundSettlement);
  yield takeLatest(REQUEST_VEHICLE_MODEL_DATA, getAllVehicleModel);
  yield takeLatest(
    REQUEST_VEHICLE_DATA_USERID_DATA,
    getAllVehicleDataByUserIdInfo
  );
  yield takeLatest(
    REQUEST_DELETE_VEHICLE_DATA_USERID_DATA,
    deleteVehicleRecordsData
  );
  // getAllSettlementListOfUserById
  yield takeLatest(
    REQUEST_ALL_USER_SETTLEMENT_AFFILIATEID,
    getAllSettlementListOfUserById
  );

  yield takeLatest(
      REQUEST_ALL_SETTLEMENT_LIST_OF_USER_BY_ID_FOR_GROUP,
      getAllSettlementListOfUserByIdForGroup
    );

  //getSettlementDetailForGroup
  yield takeLatest(
      GET_SETTLEMENT_DETAIL_FOR_GROUP,
      getSettlementDetailForGroup
    );

  yield takeLatest(
    REQUEST_VIEW_VEHICLE_DATA_USERID_DATA,
    viewVehicleEditRecord
  );
  yield takeLatest(REQUEST_SAVE_RESIDENCE_DATA, saveResidences);
  yield takeLatest(GET_ACTIVITY_LOG, getActivityLog);
  yield takeLatest(REQUEST_CHANGE_PASSWORD_DATA, changePasswordData);
  yield takeLatest(GET_DETAIL_BYAFFILIATEKEY, getAffiliateDetailByAffiliateKey);
  yield takeLatest(REQUEST_VEHICLE_SAVE_DATA, addVehicleData);
  yield takeLatest(REQUEST_VEHICLE_SAVE_DATA_CLEAR, addVehicleDataClear);



  yield takeLatest(REQUEST_VEHICLE_MAKE_DATA, getAllVehicleMake);
  yield takeLatest(REQUEST_COUNTRY_DATA, getAllCountry);
  yield takeLatest(GET_TRANSCARD_PAYMENT_METHODS, getTranscardPaymentMethods);
  yield takeLatest(DISBURSE_AMOUNT, disbursePayment);
  yield takeLatest(TRANSFER_FUNDS_TO_ACH, transferFundsToACH);
  yield takeLatest(TRANSFER_FUNDS_TO_CARD, transferFundsToCard);
  yield takeLatest(SAVE_BUSINESS_USER_DATA, saveBusinessUser);
  yield takeLatest(SAVE_BUSINESS_USER_DATA_PARTNER, saveBusinessUserPartner);


  yield takeLatest(SAVE_BUSINESS_USER_DATA_FIRST_STEP, saveBusinessUserStep1);
  yield takeLatest(CLEAR_BUSINESS_USER_DATA_FIRST_STEP, clearBusinessData);
  yield takeLatest(REQUEST_CHILDCOMPAY_DATA, getAllChildCompanyProfile);
  yield takeLatest(REQUEST_CONSUMERUPDATE_DATA, updateConsumerUserData);
  yield takeLatest(
    REQUEST_DEFENDENT_AUTO_DATA,
    getAutoPartDefendentPartsByPartId
  );
  yield takeLatest(REQUEST_SAVE_UNELIGIBLE, saveUsersUneligibleSettlements);
  yield takeLatest(REQUEST_BUSINESSCOMPANY_DATA, updateBusinessCompany);
  yield takeLatest(REQUEST_VIEW_BUSINESSCOMPANY_DATA, viewCompanyChildRecord);
  yield takeLatest(
    REQUEST_BUSINESSCOMPANY_UPDATE_DATA,
    updateBusinessCompanyData
  );
  yield takeLatest(
    REQUEST_DELETE_BUSINESSCOMPANY_DATA,
    deleteCompanyChildRecord
  );
  yield takeLatest(REQUEST_BUSINESSUPDATE_DATA, updateBusinessUserData);
  yield takeLatest(REQUEST_UPLOADFILE_DATA, uploadFile);
  yield takeLatest(QUESTION_TYPE_FILE,uploadsEligibilityQuestionFileByUser);
  yield takeLatest(QUESTION_TYPE_FILE_DELETE,deletesEligibilityQuestionFileByUser);
  yield takeLatest(REQUEST_UPLOADFILE_DATA_DOC, updateUserSignatureWithDocs);
  yield takeLatest(SAVE_CONSUMER_USER_DATA, saveConsumerUser);
  yield takeLatest(GET_ALL_STATES, getAllState);
  yield takeLatest(REQUEST_FORGET_PASSWORD, requestForgetPassword);
  yield takeLatest(GET_ALL_PLANES, requestAllPlans);
  yield takeLatest(REQUEST_USER_EMAIL, confirmUserEmail);
  yield takeLatest(REQUEST_BUSINESS_DATA, getBusinessList);
  yield takeLatest(REQUEST_BUSINESSUSER_DATA, getBusinessUser);
  yield takeLatest(
    REQUEST_NOTIFICATION_DATA,
    getNotificationLogUnReadCountForUser
  );

  yield takeLatest(REQUEST_BUSINESSUSER_DATA_AFFI, getBusinessUserAffilate);

  yield takeLatest(REQUEST_CONSUMERUSER_DATA, getConsumerUser);
  yield takeLatest(LINK_ACCOUNT_PROFILE_PAGE, createTranscardAccountData)
  yield takeLatest(LINK_CARD_PROFILE_PAGE, createTranscardCardData)
  yield takeLatest(GET_ADDED_BANK_ACCOUNT_FOR_USER,getAddedBankAccountsForUser);
  yield takeLatest(GET_ADDED_CARDS_FOR_USER,getAddedCardsForUser);
  yield takeLatest(GET_COLLECTED_SETTLEMENTS_HISTORY_FOR_USER,getCollectedSettlementsHistoryForUser);
  yield takeLatest(GET_ALL_BANK_ACCOUNTS_FOR_USER,getAllBankAccountsForUser);
  yield takeLatest(GET_ALL_ADDED_CARDS_FOR_USER,getAllAddedCardsForUser);
  yield takeLatest(GET_USER_TRANSACTION_HISTORY, getUserTransactionsHistory);
  yield takeLatest(SHOW_NET_AMOUNT_TO_USER,showNetAmountToUser);
  yield takeLatest (SET_DEFAULT_BANK_ACCOUNT,setDefaultBankAccount)
  yield takeLatest (SET_DEFAULT_CARD,setDefaultCard)
  yield takeLatest (ADD_USER_CARD,addUserCard)
  yield takeLatest (ADD_BUSINESS_USER_CARD,addBusinessUserCard)
  yield takeLatest (DELETE_USER_BANK_ACCOUNT,deleteUserBankAccount)
  yield takeLatest (DELETE_USER_CARD,deleteUserCard)
  yield takeLatest(ADD_USER_BANK_ACCOUNT, addUserBankAccountData)
  yield takeLatest(RECIEVE_GET_ADDED_BANK_ACCOUNT_FOR_USER, receiveGetAddedBankAccountsForUser)
  yield takeLatest(RECIEVE_GET_ADDED_CARDS_FOR_USER, receiveGetAddedCardsForUser)
  yield takeLatest(UPDATE_BANK_ACCOUNT_DETAILS, updateBankAccountDetails)
  yield takeLatest(UPDATE_CARD_DETAILS, updateCardDetails)
  yield takeLatest(REQUEST_AUTO_UPDATE_DATA, getAutoUpdateUser);

  yield takeLatest(REQUEST_INDUSTRY_DATA, getIndustryList);
  yield takeLatest(REQUEST_RESET_PASSWORD, restUserPassword);
  yield takeLatest(REQUEST_SETTLEMENT_ENRICH_QUE, SettlemetEnrichmentQuestion);
  yield takeLatest(REQUEST_ALL_SETTLEMENT, getAllSettlement);
  yield takeLatest(
    REQUEST_ALL_PROMOTED_SETTLEMENT,
    getPromotedSettlementByUserId
  );
  yield takeLatest(REQUEST_ALL_FILTEREDSETTLEMENT, getAllFilteredSettlement);
  yield takeLatest(
    REQUEST_ALL_DASHBOARD_FILTEREDSETTLEMENT,
    getAllFilteredDSettlement
  );

  yield takeLatest(
    REQUEST_ALL_FILTEREDSETTLEMENT_AFFILIATE,
    getSettlementListByAffiliateType
  );
  yield takeLatest(
    REQUEST_ALL_REFERRED_FILTEREDSETTLEMENT_AFFILIATEID,
    getAllReferredUserByAffiliateId
  );

  yield takeLatest(
      GET_ALL_GROUPS_BY_PARENT_AFFILIATE_USER,
      getAllGroupsByParentAffiliateUser
    );
  yield takeLatest(
    GET_ALL_PARTNERS_BY_GROUP,
      getAllPartnersByGroup
    ); 
  yield takeLatest(
    GET_ALL_HIERARCHY_CHILD_AFFILIATE_USERS_BY_PARENT_AFFILIATE_USER,
    getAllHierarchyChildAffiliateUsersByParentAffiliateUser
    );      

  yield takeLatest(
    REQUEST_ALL_ENROLLED_FILTEREDSETTLEMENT_AFFILIATEID,
    getEnrolledListByAffiliateId
  );

  yield takeLatest(
      GET_ENROLLED_LIST_BY_SEARCH_AND_FILTER_FOR_GROUP,
      getEnrolledListBySearchAndFilterForGroup
    );

  yield takeLatest(
    REQUEST_ALL_ENROLLED_AFFILIATEID,
    getEnrollForPartnerUser
  );
  yield takeLatest(
    GET_SETTLEMENT_LIST_FOR_GROUP,
    getSettlementListForGroup
  );

  yield takeLatest(REQUEST_ALL_ENROLLEDSETTLEMENT, getAllEnrolledSettlement);
  yield takeLatest(REQUEST_ALL_CATEGORY, getAllCategory);
  yield takeLatest(REQUEST_SETTLEMENT_FOR_USER, getEnrollSettlementForUser);
  yield takeLatest(REQUEST_ALL_FEATURE_SETTLEMENT, getAlLFeatureSettlement);
  yield takeLatest(
    REQUEST_ALL_ATTENTION_SETTLEMENT,
    getAttentionSettlementForUser
  );
  yield takeLatest(
    REQUEST_ALL_COMPLETE_SETTLEMENT,
    getCompleteSettlementForUser
  );
  yield takeLatest(SAVE_ENRICHMENT_QUESTION, saveEnrichmentQuestionAnsers);
  yield takeLatest(GET_COGNITO_ID_BY_EMAIL, getCognitoIdByEmail);
  yield takeLatest(REQUEST_CONFIRM_EMAIL_COGNITO, confirmCognitoUserEmail);
  yield takeLatest(GET_SETTLEMENT_QUESTION_ID, receiveGetSagasSettlementById);
  yield takeLatest(REQUEST_AFFILIATESUBUSER_DATA, submitSubUser);
  yield takeLatest(REQUEST_BUSINESSSUBUSER_DATA, submitSubUserBusiness);
  yield takeLatest(GET_ALL_CONSUMER_PLANES, requestAllPlansConsumer);
  yield takeLatest(REQUEST_AFFILIATESUBUSERLIST_DATA, getAllAffiliatedUsers);
  yield takeLatest(REQUEST_BUSINESSSUBUSERLIST_DATA, getAllBusinessSubUsers);
  yield takeLatest(
    REQUEST_DELETE_AFFILIATESUBUSER_DATA,
    deleteAllAffiliatedUsers
  );
  yield takeLatest(REQUEST_DELETE_BUSINESSSUBUSER_DATA, deleteBusinessSubUser);
  yield takeLatest(SAVE_SETTLEMENT_ANSWERS, saveSettlementAnswers);
  yield takeLatest(SAVE_ENROLMENT_DOC, saveEnrollmenttDocTOdB);
  yield takeLatest(UPDATE_ENROLMENT_DOC, updateEnrollmenttDocTOdB);

  yield takeLatest(CHECK_EMAIL_VERIFY, checkEmailVerify);
  yield takeLatest(GET_AFFILIATE_USER_TYPE, getAffiliateUserType);
  yield takeLatest(GET_SUBUSERBYID_TYPE, getAffiliateSubUserById);
  yield takeLatest(GET_BUSINESSSUBUSERBYID_TYPE, getBusinessSubUserById);
  yield takeLatest(GET_UPDATEAFFILIATESUBUSER_TYPE, UpdateAffiliateSubUser);
  yield takeLatest(GET_UPDATEBUSINESSSUBUSER_TYPE, UpdateBusinessSubUser);
  yield takeLatest(SAVE_ENROLMENT_AUTH, saveEnrollmentAuthorization);
  yield takeLatest(GET_COMPLETED_SETTLEMENTS, saveCompletedSettlements);
  yield takeLatest(GET_CONSUMER_RESIDENCE, getConsumerResidenceListing);
  yield takeLatest(GET_PENDING_DOCS, getPendingRequiredDoc);
  yield takeLatest(GET_PENDING_DOCS_USER, getPendingRequiredDocUser);
  yield takeLatest(
    GET_PENDING_DOCS_USER_DELETE,
    getPendingRequiredDocUserDelete
  );
  yield takeLatest(GET_ALL_VEHICLE_DATA, getAllVehicleDataByUserId);
  yield takeLatest(
    GET_ALL_VEHICLE_DATA_SETTLEMENT,
    getAllVehicleDataByUserIdSettelment
  );

  yield takeLatest(
    SAVE_MULTIPLE_VEHICLE_QUESTION_DATA,
    saveMultipleVehicleDataByUserIdAPI
  );

  yield takeLatest(DELETE_CONSUMER_RESIDENCE, deleteResidencesData);
  yield takeLatest(REQUEST_VEHICLE_TRIM_DATA, getAllVehicleTrim);
  yield takeLatest(
    GET_PENDING_SETTLEMENT_QUESTION_ID,
    getPendingsettlementQuestion
  );
  yield takeLatest(REQUEST_DISMISS_SETTLEMENT, requestDismissSettlement);
  yield takeLatest(GET_FAQ_CATEGORY, getFaqCategory);
  yield takeLatest(
    GET_All_FAQ_QUESTIONS_BY_CATEGORY_ID,
    getAllFaqQuestionBYCategoryId
  );
  yield takeLatest(GET_PAGE_DATA, getPageData);
  yield takeLatest(GET_PAGE_DATA_FOOTER, getPageDataFooter);
  yield takeLatest(GET_PAGE_DATA_IDENTITY_KEY, getUserByIdentityKey);

  yield takeLatest(GET_ACCEPT_DOCUMENT, handleAcceptedService);

  yield takeLatest(GET_CLEAR_SERVICE_DATA, clearServiceData);

  yield takeLatest(
    GET_AFFILIATE_DASHBOARD_DATA,
    getAffiliateDashboardUserAction
  );
  yield takeLatest(
    GET_AFFILIATE_DASHBOARD_USER_FOR_PARENT,
    getAffiliateDashboardUserForParent
  );
  // getBarGraphDataForDashboard
  yield takeLatest(GET_BAR_DASHBOARD_DATA, getBarGraphDataForDashboard);
  yield takeLatest(GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER, getBarGraphDataForDashboardWithSettlementIdForParentUser);
  yield takeLatest(GET_MONTHLY_ENROLLMENTS_BY_AFFILIATE_GROUP,getMonthlyEnrollmentsByAffiliateGroup);
  yield takeLatest(GET_BAR_GROUP_DATA_FOR_DASHBOARD_WITH_SETTLEMENT_ID_FOR_PARENT_USER_FOR_GROUP, getBarGraphDataForDashboardWithSettlementIdForParentUserForGroup);
  yield takeLatest(GET_PIE_DASHBOARD_DATA, getPieChartDataForDashboard);

  yield takeLatest(
    GET_PIE_DASHBOARD_STATE_DATA,
    getPieChartDataForStateDashboard
  );

  yield takeLatest(PLAN_PRICE_CHANGE, planPriceChange);
  yield takeLatest(PLAN_PRICE_CHANGE_CLEAR, clearPlanData);



  yield takeLatest(
    GET_DISMISS_SETTLEMENT_FOR_USER,
    getDismissSettlementForUser
  );
  yield takeLatest(GET_REGISTRATION_LINKS_FOR_USER, getAllAffiliateLink);
  yield takeLatest(
    SAVE_SETTLEMENT_WITHOUT_DATA,
    saveSettlementWithoutDataSagas
  );
  yield takeLatest(REQUEST_APPLY_NEXT_QUESTION, moveToNextQuestionList);
  yield takeLatest(GET_CLEAR_QUESTION_DATA, clearData);

  yield takeLatest(GET_CLEAR_ENROLLMENT_DATA, clearDataEnrollment);

  yield takeLatest(CLEAR_EMAIL_DATA, clearDataEmail);
  yield takeLatest(CLEAR_CONSUMER_LOGIN_DATA, RecieveConsumerUserDataClear);
  yield takeLatest(CLEAR_BUSINESS_LOGIN_DATA, RecieveBussnessUserDataClear);
  yield takeLatest(GET_CLEAR_CHANGEPASSWORD_DATA, clearDataChange);
  yield takeLatest(GET_CLEAR_SETTLEMENTANSWER_DATA, clearDataSettlmentanswers);
  yield takeLatest(REQUEST_SAVE_APPLY_NEXT_QUESTION, saveToNextQuestionList);
  yield takeLatest(GET_ALL_ELIGIBILITY_BACK, getEligibilityQuestionById);
  yield takeLatest(GET_ALL_NOTIFICATIONS, getAllNotifications);
  yield takeLatest(GET_MARK_NOTIFICATIONS, markNotificationReadForUser);

  yield takeLatest(DELETE_NOTIFICATION, deleteNotification);
  yield takeLatest(MARK_ALL_READ_NOTIFICATIONS, markAllReadNotification)
  yield takeLatest(GET_SAVE_MULTIPLE_VEHICLE_DATA, saveMultipleVehicleData);
  yield takeLatest(POST_UPLOADED_CHILD_COMPANY, uploadChildCompnayCsv);
  yield takeLatest(GET_DASHBOARD_DATA, getAllDashboardSaga);
  yield takeLatest(GET_DASHBOARD_DATA_COUNT, getAllDashboardCountSaga);
  yield takeLatest(GET_AFFILIATE_USER_TYPE_SIGNUP, GetAllAffiliateUsersByAffiliateType);
  yield takeLatest(GET_AFFILIATE_RESOURCE, getResourceSectionsAndLinks);
  yield takeLatest(GET_TRANSACTIONS_HISTORY, getUserTransactionsHistory);
  yield takeLatest(GET_DEBIT_WALLET_BALANCE, getDebitWalletBalance);
  yield takeLatest(GET_AFFILIATE_GROUP_SUCCESS, getAffiliateGroup);



}
